import { browserStackLocalUrl } from '../../../shared/cfg/browserStack.no-deps'
import { ports } from '../../../shared/cfg/ports.no-deps'
import type { Cust_ICustomer } from './Cust.ICustomer'

export function Cust_webSocketUrlGet(customer: Cust_ICustomer) {
    if (customer == null) return null

    if (ENV.useBrowserStackLocal) {
        return `ws://${browserStackLocalUrl}:${ports.websocket}`
    }

    if (customer.name === 'local') {
        return `ws://${customer.domainName}:${ports.websocket}`
    }

    return `wss://${customer.domainName}:80`
}

export function Cust_httpUrlGet(customer: Cust_ICustomer) {
    if (customer == null) return null

    if (ENV.useBrowserStackLocal) {
        return `http://${browserStackLocalUrl}:${ports.api}`
    }

    if (customer.name === 'local') {
        return `http://${customer.domainName}:${ports.api}`
    }

    return `https://${customer.domainName}`
}
